
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalWindow from '@/components/molecules/ModalWindow.vue'
import InputPassword from '@/components/molecules/InputPassword.vue'
import LabelBase from '@/components/atoms/LabelBase.vue'
import ButtonSubmit from '@/components/molecules/ButtonSubmit.vue'

/**
 * パスワード変更モーダルのフォーマット
 */
@Component({
  components: {
    ModalWindow,
    InputPassword,
    LabelBase,
    ButtonSubmit,
  },
})
export default class ModalUserPassword extends Vue {
  /** モーダル分子 */
  @Ref()
  modalWindow!: ModalWindow

  /** 確認ボタン押下時のイベント */
  @Prop()
  private eventSubmit!: (currentPassword: string, newPassword: string, confirm: string) => Promise<void>

  /** 現在のパスワード */
  private currentPassword = ''

  /** 新規パスワード */
  private newPassword = ''

  /** 確認用 */
  private confirm = ''

  /**
   * モーダルを開く
   */
  public show(): void {
    this.currentPassword = ''
    this.newPassword = ''
    this.confirm = ''
    this.modalWindow.show()
  }

  /**
   * モーダルを閉じる
   */
  public hide(): void {
    this.modalWindow.hide()
  }
}
